import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=71a38cb5&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style1 from "./Layout.vue?vue&type=style&index=1&id=71a38cb5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a38cb5",
  null
  
)

export default component.exports